import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { InvoiceTemplate } from '../models/invoice-template.model';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { plainToInstance } from 'class-transformer';
import { AddInvoiceTemplateModel } from '../models/add-invoice-template.model';
import { EditInvoiceTemplateModel } from '../models/edit-invoice-template.model';
import { AddInvoiceTemplateConceptModel } from '../models/add-invoice-template-concept.model';
import { InvoiceTemplateFilter } from '../models/invoice-template.filter.model';

@Injectable({
  providedIn: 'root'
})
export class InvoiceTemplateService {
  private apiUrl = `${environment.sgcApi}`;
  private invoiceTemplateRoute = 'invoiceTemplate';

  constructor(
    private httpClient: HttpClient
  ) {}

  getInvoiceTemplatesByFilter(user: string, exercise: number, filter: InvoiceTemplateFilter) : Observable<InvoiceTemplate[]> {
    let endpoint = `${this.apiUrl}${this.invoiceTemplateRoute}/user/${user}/exerciseId/${exercise}/filter${this.getFilters(filter)}`;
    return this.httpClient.get<InvoiceTemplate[]>(endpoint)
    .pipe(map((invoiceTemplates) => {
      return plainToInstance(InvoiceTemplate, invoiceTemplates as InvoiceTemplate[]);
    }));
  }

  getInvoiceTemplateDetails(invoiceTemplateId: string) : Observable<InvoiceTemplate> {
    let endpoint = `${this.apiUrl}${this.invoiceTemplateRoute}/${invoiceTemplateId}/management`;
    return this.httpClient.get<InvoiceTemplate>(endpoint)
    .pipe(map((invoiceTemplate) => {
      return plainToInstance(InvoiceTemplate, invoiceTemplate as InvoiceTemplate);
    }));
  }

  createInvoiceTemplate(addInvoiceTemplate: AddInvoiceTemplateModel, user: string): Observable<string> {
    let endpoint = `${this.apiUrl}${this.invoiceTemplateRoute}/user/${user}`;
    return  this.httpClient.post<string>(endpoint, addInvoiceTemplate).pipe(
      map(data => data)
    );
  }

  createInvoiceTemplateConcept(addInvoiceTemplateConcept: AddInvoiceTemplateConceptModel, user: string): Observable<string> {
    let endpoint = `${this.apiUrl}${this.invoiceTemplateRoute}/user/${user}/concept`;
    return  this.httpClient.post<string>(endpoint, addInvoiceTemplateConcept).pipe(
      map(data => data)
    );
  }

  updateInvoiceTemplate(editInvoiceTemplate: EditInvoiceTemplateModel, user: string) {
    let endpoint = `${this.apiUrl}${this.invoiceTemplateRoute}/user/${user}`;
    return  this.httpClient.put<string>(endpoint, editInvoiceTemplate).pipe(
      map(data => data)
    );
  }

  private getFilters(filter: InvoiceTemplateFilter) {
    if(filter.ceco == '' && filter.name == '' && filter.zoneId == '' && filter.isActive.toString() == '') return '';
    let urlFilter = '?filters=';
    urlFilter += filter.name != '' ? 'name=' + filter.name + ';'  : '';
    urlFilter += filter.zoneId ? 'zoneId=' + filter.zoneId.toString() + ';' : '';
    urlFilter += filter.ceco != '' ? 'ceco=' + filter.ceco + ';' : '';
    urlFilter += filter.isActive.toString()  != '' ? 'isActive=' + filter.isActive + ';' : '';
    urlFilter = urlFilter.slice(0, -1);
    return urlFilter;
  }
}
